"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Funnels = void 0;
const React = __importStar(require("react"));
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const PageLoaderComponent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/common/pageLoader/PageLoaderComponent"));
const constants_1 = require("src/hello_assets/src/constants");
const title = "Funnels";
const Funnels = () => {
    var _a, _b, _c;
    const currentProjectDataContext = (0, ProjectDashboardDataProvider_1.useProjectDashboardDataContext)();
    const state = currentProjectDataContext.stateQueryCalls;
    const inProgress = state.inProgress;
    const loaded = state.loaded;
    if (lodash_1.default.isEmpty((_c = (_b = (_a = state.data) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.uniques)) {
        if (inProgress) {
            return React.createElement(React.Fragment, null,
                React.createElement(PageContent_1.default.CardSpacer, null),
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(PageContent_1.default.CardSection, null, title),
                    React.createElement(antd_1.Result, { className: "ug-result-noIcon", status: "error", icon: React.createElement(React.Fragment, null), subTitle: React.createElement(PageLoaderComponent_1.default, null) })));
        }
        else if (loaded) {
            return React.createElement(React.Fragment, null,
                React.createElement(PageContent_1.default.CardSpacer, null),
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(PageContent_1.default.CardSection, null, title),
                    React.createElement(antd_1.Result, { className: "ug-result-noIcon", status: "error", icon: React.createElement(React.Fragment, null), subTitle: React.createElement(React.Fragment, null,
                            "To build a funnel events need to be tracked.",
                            React.createElement("br", null),
                            "You don\u2019t have any events yet.",
                            React.createElement("br", null),
                            "Please integrate the ",
                            React.createElement("a", { href: constants_1.URL_GITHUB, target: "_blank" }, "latest version of an SDK"),
                            " and follow the instructions",
                            React.createElement("br", null),
                            "to track up to 10 most important actions users can do in your dapp.") })));
        }
    }
    return null;
};
exports.Funnels = Funnels;
